import { t } from '../../../services/i18nService';
import customFieldsConstants from '../../../constants/CustomFieldsConstants';
import customFieldsService from '../../../services/CustomFieldsService';
import utilService from '../../../services/UtilService';
import sessionReader from '../../../store/readHelpers/SessionReader';

const ceqRubricsLoader = {
    getPrefix() {
        return sessionReader.isPrintStylePaperBased() ? 'pb' : 'cd';
    },

    getFocusLevel({ customFields }) {
        return customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.TESTING_FOCUS_LEVEL_1_CEQ);
    },

    getType({ customFields }) {
        return customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_TYPE);
    },

    getSubType({ customFields }) {
        return customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_SUB_TYPE);
    },

    getCaptionSubKey(question) {
        const prefix = this.getPrefix();
        const focusLevel = this.getFocusLevel(question);
        const type = this.getType(question);
        const subType = this.getSubType(question);
        const subKey = [focusLevel, type, subType].map(utilService.toCamelCaseRemoveNonAlphaNumeric).join('.');

        return `${prefix}.${subKey}`;
    },

    getCaptionReplacements({ customFields }) {
        return {
            itemRubricBlank1: customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_RUBRIC_BLANK_1),
            itemRubricBlank2: customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_RUBRIC_BLANK_2),
            itemRubricBlank3: customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_RUBRIC_BLANK_3),
            itemRubricIntroduction: customFieldsService.getCustomFieldValueWithBlanks(customFields, customFieldsConstants.ITEM_RUBRIC_INTRODUCTION),
        };
    },

    getRubricsContent(question) {
        const subKey = this.getCaptionSubKey(question);
        const replacements = this.getCaptionReplacements(question);
        return t(`rubric.question.${subKey}`, replacements);
    },
};

export default ceqRubricsLoader;
